module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1003.1ac2a772.png";